import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch } from 'react-redux';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import UndoButton from 'conversations-thread-view/alerts/components/UndoButton';
import { restoreThread as restoreThreadAction, softDeleteThread } from 'conversations-thread-data/thread-actions/public/actions';
import { getUpdatedConversation } from 'conversations-thread-view/usage-tracking/utils/threadInteraction';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';

// TODO: add usage tracking back for restore/delete
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useRestoreThread = ({
  ticket,
  threadId,
  genericChannelId
}) => {
  const dispatch = useDispatch();
  const restoreThread = () => {
    trackEvent(getUpdatedConversation({
      updateType: 'restore',
      genericChannelId
    }));
    dispatch(restoreThreadAction({
      threadId
    }));
    if (ticket) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.alerts.ticket-updates.restored"
          }), /*#__PURE__*/_jsx(UndoButton, {
            onClick: () => {
              trackEvent(getUpdatedConversation({
                updateType: 'delete',
                genericChannelId
              }));
              dispatch(softDeleteThread({
                threadId
              }));
            }
          })]
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.alerts.titles.success"
        }),
        type: 'success'
      });
    }
  };
  return {
    restoreThread
  };
};